'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _inputsLocal = require('../inputs.local.css');

var _inputsLocal2 = _interopRequireDefault(_inputsLocal);

var _selectLocal = require('./select.local.css');

var _selectLocal2 = _interopRequireDefault(_selectLocal);

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Input for making a selection from list of options
 */


var SelectInput = function SelectInput(props) {
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)([_inputsLocal2.default.wrapper, _selectLocal2.default.base, props.className]),
    dir: props.direction
  }, _react2.default.createElement(_label2.default, {
    className: (0, _classnames2.default)([_inputsLocal2.default.wrapper, _selectLocal2.default.base, props.className]),
    htmlFor: props.name,
    text: props.label
  }), props.required && _react2.default.createElement('span', {
    className: _selectLocal2.default.requiredText
  }, props.requiredLabel), _react2.default.createElement('div', {
    className: _selectLocal2.default.wrapper
  }, _react2.default.createElement('select', {
    autoFocus: props.autoFocus,
    className: (0, _classnames2.default)(_inputsLocal2.default.input, props.direction === 'rtl' ? _selectLocal2.default.rtl : null, _inputsLocal2.default['theme--' + props.theme], _selectLocal2.default.input, _defineProperty({}, _selectLocal2.default.placeholder, !props.value)),
    'data-auto': props.scope + '_' + props.name,
    disabled: props.disabled,
    id: props.name,
    multiple: props.multiple,
    name: props.name,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    readOnly: props.readOnly,
    required: props.required,
    value: props.value
  }, props.placeholder && _react2.default.createElement('option', null, props.placeholder), props.children), _react2.default.createElement(_icon2.default, {
    className: (0, _classnames2.default)(_selectLocal2.default.icon, props.direction === 'rtl' ? _selectLocal2.default.rtl : null),
    icon: 'caret'
  })));
};

SelectInput.displayName = 'UISelect';
SelectInput.defaultProps = {
  autoFocus: false,
  className: null,
  direction: 'ltr',
  disabled: false,
  label: '',
  multiple: false,
  onBlur: null,
  onChange: null,
  onFocus: null,
  readOnly: false,
  required: false,
  requiredLabel: 'Required',
  scope: 'input',
  value: ''
};
SelectInput.propTypes = {
  /**
   * HTML autoFocus attribute
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * Nest an array of <options> inside select component
   */
  children: _propTypes2.default.array.isRequired,

  /**
   * Classname attached to top-level markup
   */
  className: _propTypes2.default.string,

  /**
   * HTML disabled attribute
   */
  disabled: _propTypes2.default.bool,

  /**
   * Text direction. One of 'ltr', 'rtl'. Will add the corresponding dir attribtue to the wrapper div.
   */
  direction: _propTypes2.default.oneOf(['ltr', 'rtl']),

  /**
   * Form label to be applied above input
   */
  label: _propTypes2.default.string,

  /**
   * HTML multiple attribute
   */
  multiple: _propTypes2.default.bool,

  /**
   * Specifys name of select input
   */
  name: _propTypes2.default.string.isRequired,

  /**
   * Function called when input is blurred
   */
  onBlur: _propTypes2.default.func,

  /**
   * Function called when change occurs
   */
  onChange: _propTypes2.default.func,

  /**
   * Function called when input is focused
   */
  onFocus: _propTypes2.default.func,

  /**
   * Adds an empty option to the list to psuedo a placeholder
   */
  placeholder: _propTypes2.default.string,

  /**
   * HTML readOnly attribute
   */
  readOnly: _propTypes2.default.bool,

  /**
   * HTML required attribute
   */
  required: _propTypes2.default.bool,

  /**
   * Text to appear above input when input is required
   */
  requiredLabel: _propTypes2.default.string,

  /**
   * Define the context/scope of where this input is used
   */
  scope: _propTypes2.default.string,

  /**
   * Sets the color theme to resemble a normal or classic input
   */
  theme: _propTypes2.default.oneOf(['classic', 'normal']),

  /**
   * Current value of select component
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
exports.default = SelectInput;